"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/DropdownParticipantsPicker/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _utils = require('shared/utils');
var _log = require('shared/log');
var _ChipInputWithSelect = require('./ChipInputWithSelect'); var _ChipInputWithSelect2 = _interopRequireDefault(_ChipInputWithSelect);
var _Form = require('web/components/Form');








const formatDisplayOrgRelationship = (user) => (rel) => ({
  ...user,
  subtitle: `${rel.title || "Member"}, ${rel.orgName}`,
  orgKey: rel.orgKey,
})








const CLOSED_POPUP = {
  isPopupOpen: false,
  popupLeftCoord: 0,
  popupTopCoord: 0,
  currentCandidateKey: '',
}

/**
 * @deprecated Use *web/components/ParticipantPicker* instead.
 */
const DropdownParticipantsPicker = ({
  inputId,
  inputValue,
  onInputChange,
  users, teams, patients,
  orgKeyContext,
  inviteUserActionId,
  shouldSplatUsers,
  selectedOptions,
  onOptionRemoved,
  onOptionSelected,
  isPersonACandidate,
  isCandidateValid,
  updateCandidateStatus,
  onActionSelected,
}) => {
  const [popup, setPopup] = _react.useState(CLOSED_POPUP)
  const chipInputRef = _react.useRef(null)

  const onChipAdded = _react.useCallback.call(void 0, (chip) => {
    if (!chip) { return _log.log.error(new Error("Error. Don't have access to ref. Can't display tooltip")) }

    const { entity } = chip

    if (!isPersonACandidate(entity) || !isCandidateValid(entity.title)) return

    const popupHeight = 130
    const chipRect = chip.getBoundingClientRect()
    const top = (chipRect.bottom - popupHeight - (chipRect.height * 2) + 10)
    const left = (chipRect.right - chipRect.width)

    setPopup({
      currentCandidateKey: entity.id,
      isPopupOpen: true,
      popupLeftCoord: left,
      popupTopCoord: top,
    })
  }, [isPersonACandidate, isCandidateValid])

  const closePopup = () => setPopup(CLOSED_POPUP)

  const onPopupDismiss = () => {
    /* remove temp entities that were never created */
    selectedOptions
      .filter(isPersonACandidate)
      .map(o => o.id)
      .forEach(id => onOptionRemoved(id))

    closePopup()
  }

  const onPopupActionClicked = (action) => {
    // SAFETY: the popup's only button ids are 'patient' and 'user'.
    updateCandidateStatus(popup.currentCandidateKey, action )
    closePopup()
  }

  const handleActionSelected = (id) => {
    chipInputRef.current.focus()
    onActionSelected(id)
  }

  const { isPopupOpen, popupLeftCoord, popupTopCoord } = popup

  const inviteUserActionOption = inviteUserActionId
    ? [{ id: inviteUserActionId, text: `Invite ${inputValue}` }]
    : []

  const displayUsers = _utils.flatten.call(void 0, shouldSplatUsers
    ? users
    : users.map(u =>
      u.entityOrgRelationships.map(formatDisplayOrgRelationship(u)),
    ),
  )

  const displayItems = {
    ALL: {
      id: "ALL",
      tabName: "All",
      items: [...displayUsers, ...teams, ...patients, ...inviteUserActionOption],
    },
    USERS: {
      id: "USERS",
      tabName: "Coworkers",
      items: [...displayUsers, ...inviteUserActionOption],
    },
    TEAMS: { id: "TEAMS", tabName: "Teams", items: teams },
    PATIENTS: { id: "PATIENTS", tabName: "Patients", items: patients },
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Form.Popup, {
        left: popupLeftCoord,
        top: popupTopCoord,
        open: isPopupOpen,
        title: "Who's this contact?"  ,
        buttonOptions: [
          { id: 'patient', text: "Patient", disabled: !orgKeyContext },
          { id: 'user', text: "Collaborator", disabled: users.length > 0 },
        ],
        onClick: onPopupActionClicked,
        onClose: onPopupDismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
        , _react2.default.createElement(_ChipInputWithSelect2.default, {
          ref: chipInputRef,
          inputId: inputId,
          onInputChange: onInputChange,
          value: inputValue,
          placeholder: "Enter a name, email, or phone number..."      ,
          options: displayItems,
          selectedOptions: selectedOptions,
          onOptionSelected: onOptionSelected,
          onOptionRemoved: onOptionRemoved,
          onActionSelected: handleActionSelected,
          onChipAdded: onChipAdded, __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
        )
      )
    )
  )
}

// It was a PureComponent; React.memo keeps the shallow prop comparison.
exports. default = _react2.default.memo(DropdownParticipantsPicker)
